import React from 'react';
import { ArrowLeft, Scale } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Impressum = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <Helmet>
        <title>Impressum | ICG Hannover</title>
        <meta name="description" content="Impressum der Internationalen Christengemeinde Hannover. Angaben gemäß § 5 DDG." />
        <link rel="canonical" href="https://www.icg-hannover.de/impressum" />
      </Helmet>
      <header className="bg-gradient-to-r from-blue-600 to-purple-600 text-white py-12">
        <div className="container mx-auto px-4">
          <button
            onClick={() => navigate('/')}
            data-testid="impressum-back-btn"
            className="flex items-center gap-2 text-white/80 hover:text-white mb-6 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück zur Startseite
          </button>
          <div className="flex items-center gap-4">
            <Scale className="w-10 h-10" />
            <div>
              <h1 className="text-3xl sm:text-4xl font-bold">Impressum</h1>
              <p className="text-white/70 mt-1">Angaben gemäß § 5 DDG</p>
            </div>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-12 space-y-8 text-gray-700 leading-relaxed" data-testid="impressum-content">

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Angaben gemäß § 5 DDG</h2>
            <div className="bg-gray-50 rounded-xl p-6">
              <p className="font-semibold text-gray-900 text-lg">Internationale Christengemeinde Hannover</p>
              <p className="mt-2">Am Klagesmarkt 29</p>
              <p>30159 Hannover</p>
              <p>Deutschland</p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Kontakt</h2>
            <div className="bg-gray-50 rounded-xl p-6 space-y-2">
              <p>E-Mail: kontakt@icg-hannover.de</p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
            <div className="bg-gray-50 rounded-xl p-6">
              <p className="font-semibold text-gray-900">Internationale Christengemeinde Hannover</p>
              <p>Am Klagesmarkt 29</p>
              <p>30159 Hannover</p>
              <p>Deutschland</p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Haftungsausschluss</h2>

            <h3 className="text-lg font-semibold text-gray-800 mb-2">Haftung für Inhalte</h3>
            <p>
              Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit 
              und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß 
              § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach 
              §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte 
              fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit 
              hinweisen.
            </p>
            <p className="mt-3">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen 
              bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer 
              konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir 
              diese Inhalte umgehend entfernen.
            </p>

            <h3 className="text-lg font-semibold text-gray-800 mb-2 mt-6">Haftung für Links</h3>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. 
              Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten 
              Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten 
              wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren 
              zum Zeitpunkt der Verlinkung nicht erkennbar.
            </p>
            <p className="mt-3">
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer 
              Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links 
              umgehend entfernen.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Urheberrecht</h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen 
              Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der 
              Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. 
              Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
            </p>
            <p className="mt-3">
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte 
              Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem 
              auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei 
              Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt ein Portal zur Verbraucherstreitbeilegung bereit: 
              <a 
                href="https://consumer-redress.ec.europa.eu/index_en" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline ml-1"
              >
                https://consumer-redress.ec.europa.eu
              </a>
            </p>
            <p className="mt-3">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Bildnachweise</h2>
            <p>
              Die auf dieser Website verwendeten Bilder stammen von folgenden Quellen:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1 ml-4">
              <li>
                <a href="https://unsplash.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                  Unsplash
                </a> – Lizenzfreie Stockfotos
              </li>
              <li>Eigene Aufnahmen der Internationalen Christengemeinde Hannover</li>
            </ul>
          </section>

          <section className="bg-blue-50 rounded-xl p-6">
            <p className="text-sm text-gray-600">
              <strong>Stand:</strong> Februar 2026
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Impressum;
